if (!customElements.get('bundle-variant-form')) {
  customElements.define(
    'bundle-variant-form',
    class BundleVariantForm extends HTMLElement {
      connectedCallback() {
        this.listing = this.parseListing();
        this.button = document.getElementById(this.dataset.buttonId || 'add-bundle-item-to-cart');
        if (!this.button || !this.listing.length) { return; }

        this.onClick = this.onClick.bind(this);
        this.button.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      parseListing() {
        const json = this.querySelector('[data-bundle-listing]')?.textContent;
        if (!json) { return []; }

        try {
          return JSON.parse(json);
        } catch (error) {
          console.error('[bundle-variant-form] listing parse failed', error);
          return [];
        }
      }

      get selectedVariantId() {
        const checked = document.querySelector('variant-selector input[type="radio"]:checked');
        if (checked?.dataset.variantId) { return Number(checked.dataset.variantId); }

        const formInput = document.querySelector('.product__info-wrapper input[name="id"]');
        return formInput ? Number(formInput.value) : null;
      }

      get quantity() {
        const input = document.querySelector('.product__info-wrapper input[name="quantity"]');
        return (input && Number(input.value)) || 1;
      }

      get sellingPlanId() {
        return document.querySelector('.product__info-wrapper .selected-selling-plan-id')?.value || '';
      }

      async onClick(event) {
        event.preventDefault();

        const selectedVariantId = this.selectedVariantId;
        const entry =
          this.listing.find((item) => Number(item.id) === selectedVariantId) ||
          (this.listing.length === 1 ? this.listing[0] : null);

        if (!entry?.items?.length) { return; }

        const quantity = this.quantity;
        const sellingPlan = this.sellingPlanId ? Number(this.sellingPlanId) : null;
        const items = entry.items.map((item) => {
          const eligible = sellingPlan && Array.isArray(item.selling_plan_ids) && item.selling_plan_ids.includes(sellingPlan);

          return {
            id: item.id,
            quantity: (Number(item.quantity) || 1) * quantity,
            ...(eligible ? {selling_plan: sellingPlan} : {}),
            properties: {_is_it_bundle: 'true'},
          };
        });

        this.button.setAttribute('processing', 'true');

        const ready = await this.waitForLiquidAjaxCart();
        if (!ready || typeof window.liquidAjaxCart?.add !== 'function') {
          console.error('[bundle-variant-form] Liquid Ajax Cart add API not available');
          this.button.removeAttribute('processing');
          return;
        }

        window.liquidAjaxCart.add({items});
        setTimeout(() => this.button.removeAttribute('processing'), 1500);
      }

      waitForLiquidAjaxCart(timeout = 5000) {
        if (window.liquidAjaxCart?.init === true) { return Promise.resolve(true); }

        return new Promise((resolve) => {
          let timer = null;

          const settle = (value) => {
            clearTimeout(timer);
            document.removeEventListener('liquid-ajax-cart:init', onInit);
            resolve(value);
          };

          function onInit() {
            settle(true);
          }

          timer = setTimeout(() => settle(false), timeout);
          document.addEventListener('liquid-ajax-cart:init', onInit);
        });
      }
    },
  );
}
